import { ModuleWithProviders, NgModule } from '@angular/core';
import { BootstrapService } from './bootstrap.service';
import { BootstrapGuard } from './bootstrap.guard';

@NgModule({
    imports: [],
    declarations: [],
    providers: [],
    exports: [],
})
export class BootstrapModule {

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: BootstrapModule,
            providers: [
                BootstrapService,
                BootstrapGuard,
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/bootstrap/bootstrap.module.ts